import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import Image from 'components/Image';
import Button from 'components/Button';

import bgGrid from '../../../public/footer-half-circle/bg-grid.png';
import Link from 'components/Link';

interface Props {
  buttonLink: string;
  buttonTitle: string;
  title: string;
  description: string;
}


const FooterHalfCircle = ({ buttonLink, buttonTitle, title, description }: Props) => {
  const router = useRouter();

  return (
    <Flex
        pos="relative"
        alignItems="center"
        justify="center"
        w="100%"
        minH={["250px", null, null, null, null, "400px"]}
        overflow="hidden"
      >
        <Flex
          pos="absolute"
          w="1920px"
          left="50%"
          transform="translateX(-50%)"
          top="0"
          zIndex="-1"
          justify="center"
        >
          <Image src={bgGrid} alt="101Pay" objectFit="cover" objectPosition="center" />
        </Flex>
        <Flex
          align="center"
          flexDir="column"
          justify="center"
          p={[
            "18px",
            null,
            null,
            null,
            null,
            null,
            "0px 12%",
            null,
            "0px 16%",
            "0px 20%",
          ]}
        >
          <Text
            as="h2"
            textStyle="h2"
            mb={["10px", null, null, null, null, "34px"]}
            fontSize={["18px", null, null, null, null, "48px"]}
            fontWeight="300"
            textAlign="center"
          >
            {title}
          </Text>
          <Box maxWidth={["300px", null, null, "514px"]}>
            <Text
              textStyle="paragraph"
              mb={["53px"]}
              fontSize={["0.875rem", null, null, null, null, "21px"]}
              textAlign="center"
              fontWeight="300"
            >
              {description}
            </Text>
            <Button
              href="#"
              minW={["291px", null, null, null, null, "444px"]}
              onClick={() => router.push(buttonLink)}
              m="auto"
              display="block"
              variant="outline"
              mb={["auto", null, null, null, null, "5px"]}
            >
              {buttonTitle}
            </Button>
          </Box>
        </Flex>
      </Flex>
  )
}

export default FooterHalfCircle;